<div class="dl-cytocanvas__container dl-simcanvas__container" #cytoContainer></div>
@if (genereren()) {
    <div class="dl-simcanvas__genereren" role="status">
        <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
    </div>
}
